import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { InvitacionVisitaDTO } from "../../models/invitacion-visita.model";
import { environment as ENV } from "environments/environment";
import { BehaviorSubject, Observable, of } from "rxjs";
import { InvitacionCotizarDTO } from "../../interfaces/invitacion.interface";
const API = "visitas/";
@Injectable({
    providedIn: "root",
})
export class VisitaService {
    invitacionesRefresh$: BehaviorSubject<boolean>;
    constructor(private http: HttpClient) {
        this.invitacionesRefresh$ = new BehaviorSubject(null);
    }

    grabarInvitacionVisita(
        idServicioSolicitudCotizacion: number,
        invitacion: InvitacionVisitaDTO
    ) {
        const requestOptions: Object = {
            responseType: "text",
        };

        return this.http.post<any>(
            `${ENV.apiUrl}${API}invitacion/${idServicioSolicitudCotizacion}`,
            invitacion,
            requestOptions
        );
    }

    fetchInvitaciones(
        idServicioSolicitudCotizacion: number
    ): Observable<InvitacionCotizarDTO[]> {
        return this.http.get<InvitacionCotizarDTO[]>(
            `${ENV.apiUrl}${API}invitacion/${idServicioSolicitudCotizacion}`
        );
    }
}
